var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.link,"download":_vm.name + '.png',"title":"Download as PNG"}},[_vm._v(" 🖨 ")])}
var staticRenderFns = []

export { render, staticRenderFns }